/**
 * This is the entry point of the application.
 * Must be defined on this way to allow Module Federation to work properly.
 */
import('./bootstrap')

export {}
